<div *ngIf="(headerType$ | async) as headerType">
    <main-header *ngIf="headerType === 'main'; else customHeader"></main-header>

    <ng-template #customHeader>
        <custom-header  [titleTag]="headerType" [customStyle]="customStyle"></custom-header>
    </ng-template>
</div>
